import { Link } from 'react-router-dom';
import { ArrowRight, Building2, Heart, TestTube } from 'lucide-react';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-spire-purple via-spire-purple-light to-spire-green flex items-center justify-center p-6">
      <div className="max-w-6xl w-full">
        <div className="text-center mb-16">
          <img src="/spire-logo.png" alt="Spire Group" className="h-20 w-auto mx-auto mb-8 drop-shadow-2xl" />
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 drop-shadow-lg">
            Spire Group Testing Portal
          </h1>
          <p className="text-xl md:text-2xl text-white/90 mb-4 drop-shadow-md">
            Choose a site version to explore
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Full Site Card */}
          <Link to="/full-site" className="group">
            <div className="bg-white rounded-3xl p-10 shadow-2xl hover:shadow-3xl transition-all duration-500 hover:-translate-y-2 border-4 border-transparent hover:border-spire-purple">
              <div className="flex items-center justify-center mb-6">
                <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-spire-purple to-spire-purple-light flex items-center justify-center">
                  <Building2 className="text-white" size={40} />
                </div>
              </div>
              
              <h2 className="text-3xl font-bold text-gray-900 mb-4 text-center">Full Site</h2>
              <p className="text-gray-600 text-center mb-6 leading-relaxed">
                Complete website featuring both <span className="font-semibold text-spire-purple">Healthcare</span> and <span className="font-semibold text-spire-green">Commercial</span> real estate services
              </p>
              
              <div className="flex items-center justify-center space-x-2 text-spire-purple font-semibold group-hover:translate-x-2 transition-transform">
                <span>Explore Full Site</span>
                <ArrowRight size={20} />
              </div>
              
              <div className="mt-6 pt-6 border-t border-gray-200">
                <div className="flex items-center justify-center space-x-4 text-sm text-gray-500">
                  <span className="flex items-center">
                    <Heart size={16} className="mr-1 text-spire-purple" />
                    Healthcare
                  </span>
                  <span>+</span>
                  <span className="flex items-center">
                    <Building2 size={16} className="mr-1 text-spire-green" />
                    Commercial
                  </span>
                </div>
              </div>
            </div>
          </Link>

          {/* Healthcare Only Card */}
          <Link to="/healthcare-only" className="group">
            <div className="bg-white rounded-3xl p-10 shadow-2xl hover:shadow-3xl transition-all duration-500 hover:-translate-y-2 border-4 border-transparent hover:border-spire-purple">
              <div className="flex items-center justify-center mb-6">
                <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-spire-purple to-pink-500 flex items-center justify-center">
                  <Heart className="text-white" size={40} />
                </div>
              </div>
              
              <h2 className="text-3xl font-bold text-gray-900 mb-4 text-center">Healthcare Only</h2>
              <p className="text-gray-600 text-center mb-6 leading-relaxed">
                Specialized website focused exclusively on <span className="font-semibold text-spire-purple">Medical & Healthcare</span> real estate leasing services
              </p>
              
              <div className="flex items-center justify-center space-x-2 text-spire-purple font-semibold group-hover:translate-x-2 transition-transform">
                <span>Explore Healthcare Site</span>
                <ArrowRight size={20} />
              </div>
              
              <div className="mt-6 pt-6 border-t border-gray-200">
                <div className="flex items-center justify-center space-x-2 text-sm">
                  <Heart size={16} className="text-spire-purple" />
                  <span className="text-gray-700 font-semibold">Medical Real Estate Specialists</span>
                </div>
              </div>
            </div>
          </Link>
        </div>

        <div className="mt-12 text-center">
          <p className="text-white/80 text-sm">
            &copy; {new Date().getFullYear()} Spire Group Inc. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;